"use client"

import { motion } from "framer-motion"
import { Rocket, FileText, Plug } from "lucide-react";
import { cn } from "src/lib/utils";

export type FloatingActionIcon = 'template' | 'rocket' | 'plug';

export default function FloatingAction({ position, text, icon }: {position: string, text: string, icon: FloatingActionIcon}) {
    const Icon = {
        'template': FileText,
        'rocket': Rocket,
        'plug': Plug,
    }[icon];

    return (
       <motion.div
            initial={{ opacity: 0, y: 20, scale: 0.9 }}
            whileInView={{ opacity: 1, y: 0, scale: 1 }}
            transition={{ duration: 0.6, delay: 1.4, ease: "easeOut" }}
            viewport={{ once: true, margin: "-50px" }}
            whileHover={{ scale: 1.05 }}
            className={cn("absolute", position)}
        >
            <div className="bg-gradient-to-r from-blue-600 to-purple-600 text-white px-4 py-2 md:px-6 md:py-3 rounded-full shadow-lg flex items-center gap-2">
                {Icon && <Icon className="size-4" />}
                <span className="text-[11px] md:text-sm font-medium">{text}</span>
            </div>
        </motion.div>
    )
}